module.exports = __webpack_public_path__ + "static/media/Video.25cab493.svg";